import { RootState } from '@app/redux/root-reducer';

export const selectAddLeaveState = (store: RootState) => store.leavesReducer.addLeave;
export const selectLeaveState = (store: RootState) => store.leavesReducer.leaves;
export const selectUpdateLeaveStatusState = (store: RootState) =>
  store.leavesReducer.updateLeaveStatus;
export const selectUpdateLeaveState = (store: RootState) => store.leavesReducer.updateLeave;
export const selectLeaveDetailsState = (store: RootState) => store.leavesReducer.leaveDetails;
export const selectSendLeaveState = (store: RootState) => store.leavesReducer.sendLeave;
export const selectSendToManager = (store: RootState) => store.leavesReducer.sendToManager;
export const selectGetUsersState = (store: RootState) => store.leavesReducer.getUsers;
export const selectAddExistingLeaveState = (store: RootState) =>
  store.leavesReducer.addExistingLeave;
